import {actionMap} from '../reducers/index'
import * as types from './types'

export default (params) => dispatch => {
    dispatch({
        type: types.SELECT_DOCUMENT,
        params: params
    })
}

export const handler_SELECT_DOCUMENT = (reduxState, action) => {
    let newSelection = reduxState.selectedIds !== undefined ? reduxState.selectedIds : []

    if (action.params.checked) {
        newSelection.push(action.params.selection)
        newSelection = newSelection.slice(0)
    }
    else {
        newSelection = newSelection.filter(item => item !== action.params.selection)
    }

    return ({
        ...reduxState,
        selectedIds: newSelection
    })
}

actionMap[types.SELECT_DOCUMENT] = handler_SELECT_DOCUMENT


// WEBPACK FOOTER //
// ./src/screens/sigcharts/actions/selectDocument.js